import api from '../../services/api';
import { OPERATOR_REQUEST_CONFIG, warehousePath } from '../operator/operatorApi';

/*
 * Dispatch on the floor: the orders ready to leave, and the load that goes up
 * the truck. The floor calls an item a «bulto». An order goes up by scanning
 * its items — each one when every item has its own label, or its shipment
 * label once and then counting — and leaves whole or not at all.
 */

/**
 * The orders ready to leave, in the tray's order, the blocked ones last; and
 * how many each courier has (`couriers`).
 *
 * @param {number|string} warehouseId
 * @param {{courier?: string, page?: number}} [params]
 */
export const getDispatchOrdersRequest = (warehouseId, { courier = '', page = 1 } = {}) =>
  api.get(warehousePath(warehouseId, 'dispatch/orders/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { page, ...(courier ? { courier } : {}) },
  });

/**
 * What a label read at dispatch is: `{order, item_id, match}`, `match` being
 * `item` (the label of one item) or `shipment` (the one label of the order).
 * 409 for an order that is not for dispatch, or is blocked; 404 for a code
 * that is nothing in this warehouse.
 *
 * @param {number|string} warehouseId
 * @param {string} code
 */
export const scanDispatchRequest = (warehouseId, code) =>
  api.get(warehousePath(warehouseId, 'dispatch/scan/'), { ...OPERATOR_REQUEST_CONFIG, params: { code } });

/**
 * Dispatches the load: each order with the items scanned (`item_ids`), or how
 * many were counted under its one label (`items_count`). Each order answers
 * on its own; one that fails does not stop the rest.
 *
 * @param {number|string} warehouseId
 * @param {{orders: Array<{order_id: number, item_ids?: number[], items_count?: number}>, idempotency_key: string}} body
 */
export const dispatchRequest = (warehouseId, body) =>
  api.post(warehousePath(warehouseId, 'dispatch/'), body, OPERATOR_REQUEST_CONFIG);
